<template>
  <div>
    <Titulo texto="SISTEMA DE ADMISIÓN ESCOLAR" />
    <div
      class="bg-white d-flex align-items-center justify-content-center px-2 py-4 p-lg-5 border border-2 border-azul-claro2 mx-3"
    >
      <div class="text-center">
        <FontAwesomeIcon icon="check" class="fa-3x text-success" />
        <div class="h3 text-success font-weight-bold mt-4">
          Comprobante descargado
        </div>
        <div
          class="p-3 m-2 col-auto alert alert-warning justify-content-center h5 d-none d-lg-block mt-4"
        >
          Ubica tu comprobante en la
          <strong>carpeta de descargas</strong> de tu navegador
        </div>
        <div
          class="p-3 m-2 col-auto alert alert-warning justify-content-center h5 d-block d-lg-none mt-4"
        >
          Ubica tu comprobante en las
          <strong>descargas</strong> de tu móvil
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Titulo from "@/components/generales/Titulo";
import ApiComprobante from "@/service/ApiComprobante";
import { PdfDocument } from "@/utils/pdfMake/constructorPDF";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faCheck);
export default {
  components: {
    Titulo,
    FontAwesomeIcon
  },
  data() {
    return {
      jwt: "",
      postulacionData: {},
      url: window.location.origin,
      mostrarMatricula: ""
    };
  },
  mounted() {
    this.comprobarJWT();
    const obtenerValorLocalStorage = (key, valorPorDefecto = "----") => {
      const valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.TERMINO_ETAPA_1_RESULTADOS = obtenerValorLocalStorage(
      "C_terminoEtapa1Resultados"
    );
    this.PERIODO_COMPLEMENTARIO = obtenerValorLocalStorage(
      "C_periodoComplementario"
    );
    this.PERIODO_LISTA_ESPERA_RESULTADO = obtenerValorLocalStorage(
      "C_periodoListaEsperaResultado"
    );
    this.PERIODO_REGULARIZACION = obtenerValorLocalStorage(
      "C_periodoRegularizacion"
    );
    this.FECHA_LIMITE_MODIFICACION_POSTULACION = obtenerValorLocalStorage(
      "C_fechaLimiteModificacionPostulacion"
    );
    this.FECHA_PUBLICACION_RESUL_COMPLEMENTARIO = obtenerValorLocalStorage(
      "C_fechaPublicacionResultadoComplementario"
    );
    this.ANIO_ESCOLAR = obtenerValorLocalStorage("C_anioEscolar");
    this.MOSTRAR_MATRICULA_ASEGURADA = obtenerValorLocalStorage(
      "C_mostrarMatriculaAsegurada"
    );
    this.FECHA_FIN_POSTULACION = obtenerValorLocalStorage(
      "C_fechaFinPostulacion"
    );
    this.FECHA_RESULTADOS = obtenerValorLocalStorage("C_fechaResultados");
    if (this.MOSTRAR_MATRICULA_ASEGURADA == "1") {
      this.MOSTRAR_MATRICULA_ASEGURADA = true;
    } else {
      this.MOSTRAR_MATRICULA_ASEGURADA = false;
    }
  },
  methods: {
    async generateComprobante(postulacion) {
      let nombreDocumento = `Comprobante Postulacion ${
        postulacion.postulante.run
      }-${postulacion.postulante.digitoVerificador}`;

      let titulo =
        postulacion.periodo == "1"
          ? "COMPROBANTE POSTULACIÓN"
          : "COMPROBANTE POSTULACIÓN PERIODO COMPLEMENTARIO";

      PdfDocument.init();
      // Header solo en la primera página y footer solo en la última
      PdfDocument.setModoCompacto(true);
      PdfDocument.setTituloDerecha(postulacion.periodo);
      PdfDocument.setFolio(postulacion.id);
      this.insertarHeader(postulacion, titulo);

      if (postulacion.periodo == "2") {
        PdfDocument.createBannerPostulacionFamiliar();
      }
      // QR a la izquierda e información importante a la derecha
      PdfDocument.createQRconInformacionImportante(
        this.generarURLqr(),
        postulacion,
        null,
        false
      );
      // Margen chico para que quede pegado al bloque del QR
      PdfDocument.createBannerInformacionFinal(5);
      PdfDocument.createImagenLineaDeTiempo();
      PdfDocument.openSinglePage(nombreDocumento);
      PdfDocument.reset();
    },
    insertarHeader(postulacion, titulo) {
      PdfDocument.createTitle(postulacion);
      PdfDocument.createBannerEstado(postulacion, titulo);

      // Las preferencias van en la misma página, bajo el banner de estado
      PdfDocument.createPreferencias(
        postulacion.preferencias,
        postulacion.periodo ? postulacion.periodo : 1
      );
      if (
        this.mostrarMatricula &&
        postulacion.postulante.establecimiento &&
        postulacion.preferencias.length === 1
      ) {
        PdfDocument.createMatriculaAsegurada(
          postulacion.postulante.establecimiento
        );
      }
    },

    generarURLqr() {
      let origen = this.url;
      let urlQr = "";
      if (!origen) {
        origen = "http://nc-ext-ibraramo.mineduc.cl:8060/";
        urlQr = origen + "validar/?postulacion=" + this.jwt;
      } else {
        urlQr = origen + CONTEXT + "/validar?postulacion=" + this.jwt;
      }
      return urlQr;
    },
    comprobarJWT() {
      this.jwt = this.$route.query.postulacion;
      this.postulacionData = this.$route.params.datos;
      if (!this.postulacionData || this.postulacionData === "") {
        this.validarComprobante();
      } else {
        this.generateComprobante(this.postulacionData);
      }
    },
    async validarComprobante() {
      if (this.jwt) {
        let validar = await ApiComprobante.validarComprobante(this.jwt, this);
        if (validar) {
          this.generateComprobante(validar);
        } else {
          this.$router.push({
            name: "Validar",
            query: {
              postulacion: this.jwt
            }
          });
        }
      } else {
        this.$emit(
          "onError",
          "Ha ocurrido un error en el proceso. Vuelva a intentarlo.",
          "ERROR DE AUTORIZACIÓN",
          true,
          "Sae",
          "SISTEMA DE ADMISIÒN ESCOLAR"
        );
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/DescargarComprobante.vue